'use client'

import { sortDateStrings, fromISOtoLocal } from 'shared-utils/date-utils'
import type { IDatepickerStrings } from 'shared-types/datepicker'
import { PktTag } from '../tag/Tag'

interface DateTagsProps {
  dates: string[]
  dateformat: string
  idBase: string
  strings?: IDatepickerStrings
  onDateRemoved: (date: string) => void
}

export const DateTags = ({
  dates,
  dateformat,
  idBase,
  strings,
  onDateRemoved,
}: DateTagsProps) => {
  const sorted = sortDateStrings(dates)
  const deleteLabel = strings?.calendar?.buttonAltText ?? 'Slett dato'

  return (
    <div className="pkt-date-tags pkt-datepicker__tags" aria-live="polite">
      {sorted.map((date) => {
        const formatted = fromISOtoLocal(date, dateformat)
        return (
          <PktTag
            key={date}
            id={`${idBase}${date}-tag`}
            closeTag
            ariaLabel={`${deleteLabel} ${formatted}`}
            onClose={() => onDateRemoved(date)}
          >
            <time dateTime={date}>{formatted}</time>
          </PktTag>
        )
      })}
    </div>
  )
}
